import React from "react";
import Section from "./Section";
import Container from "react-bootstrap/Container";
import SectionHeader from "./SectionHeader";
import Pricing from "./Pricing";
import { useAuth } from "util/auth";
import { useRouter } from 'util/router'

function PricingSection(props) {

  const auth = useAuth()
  const router = useRouter()

  const selectedPlan = auth?.stripePartner?.planId;

  console.log("here's auth: ", auth)

  

  var pricingItems = (props.studioMode === true || router.query.secret == 'studios-only') ? 
  [
    {
      selected: selectedPlan === "premierMonthly" || selectedPlan === "premierAnnual",
      id: "premierMonthly",
      monthlySelected: selectedPlan === "premierMonthly",
      annualId: "premierAnnual",
      annualSelected: selectedPlan === "premierAnnual",
      annualPrice: "500",
      selectedPlan: selectedPlan,
      name: "Sutra Collective",
      bookingFee: "3% booking fee",
      price: "50",
      perks: [
        "Add multiple instructors",
        "On demand content",
        "Unlimited in-person & virtual classes",
        "Class packs & subscriptions",
        "Embed booking into your website",
        "Zoom integration",
        "Liability waivers",
        "Client management",
        "White glove setup service"
      ],
    },
    {
      selected: selectedPlan === "collectiveWebsiteMonthly" || selectedPlan === "collectiveWebsiteAnnual",
      id: "collectiveWebsiteMonthly",
      monthlySelected: selectedPlan === "collectiveWebsiteMonthly",
      annualId: "collectiveWebsiteAnnual",
      annualSelected: selectedPlan === "collectiveWebsiteAnnual",
      annualPrice: "750",
      selectedPlan: selectedPlan,
      name: "Sutra Collective + Website",
      bookingFee: "3% booking fee",
      price: "75",
      perks: [
        "Everything on the Collective Plan",
        "Custom website design & hosting"
      ],
    }
  ] : [ // END STUDIO
    {
      selected: selectedPlan === "proMonthly" || selectedPlan === "proAnnual",
      id: "proMonthly",
      monthlySelected: selectedPlan === "proMonthly",
      annualId: "proAnnual",
      annualSelected: selectedPlan === "proAnnual",
      annualPrice: "21",
      selectedPlan: selectedPlan,
      name: "Sutra Pro",
      bookingFee: "3% booking fee",
      price: "25",
      perks: [
        "Everything in the Starter plan",
        "Class packs & subscriptions",
        "Liability waivers",
        "Client management",
        "On demand content",
      ],
    },
    {
      selected: selectedPlan === "premierMonthly" || selectedPlan === "premierAnnual",
      id: "premierMonthly",
      monthlySelected: selectedPlan === "premierMonthly",
      annualId: "premierAnnual",
      annualSelected: selectedPlan === "premierAnnual",
      annualPrice: "40",
      selectedPlan: selectedPlan,
      name: "Sutra Premier",
      bookingFee: "3% booking fee",
      price: "50",
      perks: [
        "Everything in the Sutra Pro plan",
        "Custom website & hosting",
        "White glove setup service"
      ],
    },
  ]

  if ((router.pathname.includes('dashboard') || router.query.starter == 'starter') && !props.studioMode) {
    pricingItems = [{
      id: "starter",
      selected: selectedPlan === "starter",
      monthlySelected: selectedPlan === "starter",
      name: "Starter",
      bookingFee: "8% booking fee",
      price: "0",
      perks: [
        "Unlimited in-person & virtual classes",
        "Zoom integration",
        "Embed booking into your website",
      ],
    }].concat(pricingItems)
  }

  return (
    <Section
      bg={props.bg}
      textColor={props.textColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <Container>
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={2}
          spaced={true}
          className="text-center"
        ></SectionHeader>
        {selectedPlan && selectedPlan !== "starter" && (
          <button
            onClick={() => {
              router.push("/settings/billing")
            }}
            type="button"
           className="btn btn-link">
            Open Billing
          </button>
        )}
        <Pricing
          buttonText="Choose"
          items={pricingItems}
        ></Pricing>
      </Container>
    </Section>
  );
}

export default PricingSection;
